import { FormikValues } from 'formik';

import {
  bookedRating,
  getBookedRating,
  getRatingItems,
  rate,
  ratingItems,
} from '@pharmaplan/common';

import { useEffect, useMemo } from 'react';
import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';
import { resetDialog } from '../../reducers/dialogReducer';
import strings from '../../localization';

export interface IUsePharmacistRatingCommon {
  id: string;
  bookingId: string;
  ratingLevel: { [key: string]: number };
  favState: boolean;
}

const usePharmacistRating = ({
  id,
  bookingId,
  ratingLevel,
  favState,
}: IUsePharmacistRatingCommon) => {
  const dispatch = useAppDispatch();

  const ratingData = useAppSelector(ratingItems);
  const bookedRatingData = useAppSelector(bookedRating);
  const { pharmacistRatingItems } = ratingData ?? {};
  const { data, comment: bookedComment } = bookedRatingData ?? {};

  const maxRatedItemsPossible = pharmacistRatingItems.length;

  const handleSubmit = (values: FormikValues) => {
    const levels = pharmacistRatingItems.map((item) => {
      const { pharmacistRatingItemId } = item ?? {};
      return {
        pharmacistRatingItemId,
        level: ratingLevel[pharmacistRatingItemId] ?? 0,
      };
    });

    const { comment } = values ?? {};

    dispatch(
      rate({
        bookingId: bookingId ?? '',
        levels: [...levels],
        favorite: favState,
        comment,
        pharmacistId: id,
      }),
    );
    dispatch(resetDialog());
  };

  useEffect(() => {
    dispatch(getRatingItems(id));
    dispatch(getBookedRating(bookingId ?? ''));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialRatingFeedback = useMemo(
    () =>
      ({
        questions: [],
        ratingFeedback: {},
      }),
    [],
  );

  return {
    data,
    bookedComment,
    maxRatedItemsPossible,
    handleSubmit,
    ratingData,
    bookedRatingData,
    userRatingItems: pharmacistRatingItems,
    idProperty: 'pharmacistRatingItemId',
    displayDetailForm: true,
    ...initialRatingFeedback,
    questionProperty: '',
    title: strings.myProfessionalRating,
  };
};

export default usePharmacistRating;
